module.exports = __webpack_public_path__ + "img/denunciar.01acb4c1.svg";